import { useEffect, useState } from 'react'
import useCallApi from '../../../utilities/axios'

import useAuthenStore from '../../../stores/authen/authenStore'

type GetSync = {
    isSync: boolean
    lineID: string | null
    userID: string | number
    username: string
}

function useGetSync() {
    const callApi = useCallApi()
    const authenStore = useAuthenStore()
    const userID = authenStore.profile?.userId

    const [isSync, setSync] = useState(false)

    useEffect(() => {
        if (!userID) return

        async function fetch() {
            try {
                const { data } = await callApi.axiosGet<GetSync>({
                    url: `${process.env.REACT_APP_CU_IRB_API_URL}/line/sync/${userID}`,
                })

                setSync(data.isSync)
            } catch (error) {
                console.log('error', error)
            }
        }

        fetch()
    }, [userID])

    return { isSync }
}

export default useGetSync
